import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import GridOnIcon from '@mui/icons-material/GridOn'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import { ICON_MD } from '../common/theme'
import { fileExt } from '../services/KnowledgeBaseService'

export function FileTypeIcon({ name }: { name: string }) {
  const ext = fileExt(name)
  if (ext === 'PDF') return <PictureAsPdfOutlinedIcon sx={{ fontSize: ICON_MD, color: '#e05c5c' }} />
  if (ext === 'DOC' || ext === 'DOCX') return <DescriptionOutlinedIcon sx={{ fontSize: ICON_MD, color: '#1976d2' }} />
  if (ext === 'XLS' || ext === 'XLSX' || ext === 'CSV') return <GridOnIcon sx={{ fontSize: ICON_MD, color: '#43a047' }} />
  if (ext === 'TXT' || ext === 'RTF') return <ArticleOutlinedIcon sx={{ fontSize: ICON_MD, color: 'text.secondary' }} />
  return <InsertDriveFileOutlinedIcon sx={{ fontSize: ICON_MD, opacity: 0.55 }} />
}
